import { MapLatLng } from './map.latlng';

export abstract class MapCircle {
    public id: number;            // Identificador secuencial
    public map: any;              // Mapa nativo
    public dataModel: any;        // Objeto asociado (modelo de negocio)
    public content: string;       // Contenido que aparece cuando pasa el cursor por encima
    public strokeColor: string;
    public strokeOpacity: number;
    public strokeWeight: number;
    public fillColor: string;
    public fillOpacity: number;
    public center: MapLatLng;
    public radius: number;
    public editable: boolean;
    public draggable: boolean;
    // Agregados
    public clickPoint?: MapLatLng; // Punto sobre el que se ha pinchado en el mapa

    constructor(id: number, map: any, content: string, strokeColor: string, strokeOpacity: number,
        strokeWeight: number, fillColor: string, fillOpacity: number, center: MapLatLng,
        radius: number, editable: boolean, draggable: boolean) {
        this.id = id;
        this.map = map;
        this.content = content;
        this.strokeColor = strokeColor;
        this.strokeOpacity = strokeOpacity;
        this.strokeWeight = strokeWeight;
        this.fillColor = fillColor;
        this.fillOpacity = strokeOpacity;
        this.center = center;
        this.radius = radius;
        this.editable = editable;
        this.draggable = draggable;
    }

    abstract remove(): any;
    abstract setContent(content: string): any;
    abstract setCenter(position: MapLatLng): any;
    abstract setRadius(radius: number): any;

    setData(data: any) {
        this.dataModel = (data !== undefined ? data : null);
    }
}
